import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { PhoneNumberUtil } from 'google-libphonenumber';


export function phoneNumberValidator(formControl: FormControl): ValidatorFn {
  const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

  return (control: AbstractControl): {[key: string]: any} | null => {
    if (formControl.value) {
      return phoneUtil.isValidNumber(formControl.value) ? null : { phoneNumber: { value: control.value } };
    }
    return null;
  };

}

export function phoneNumberNFValidator(stringToCheck: string) {

  const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

  if (stringToCheck) {
    const parserPhoneNumber = phoneUtil.parse(stringToCheck);
    return phoneUtil.isValidNumber(parserPhoneNumber) ? null : { phoneNumber: { value: stringToCheck } };
  }

  return null;
}
